import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../components/Loader';
import { fetchVehicle } from '../actions';
import { selectVehicle } from '../selectors';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WithVehicleComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (!this.props.vehicle) this.props.fetch();
  }

  render() {
    if (!this.props.vehicle) return this.props.loader ? <Loader small /> : null;

    return this.props.children;
  }
}

WithVehicleComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      if (!ownProps.vehicle_id) return;
      dispatch(fetchVehicle(ownProps.vehicle_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WithVehicle = compose(withConnect, withRouter)(WithVehicleComp);
